// Convierte { code, data } de ApiRequestInterceptor al shape que usa el store:
// { statusCode, message, ...data }
export const normalizeResponse = (response, mensajeError) => {
  const { code, data } = response;

  if (code >= 200 && code < 300) {
    return { statusCode: code, ...(data || {}) };
  }

  return {
    statusCode: code || 500,
    message: data?.message || mensajeError,
  };
};
